import { Fragment, type ReactNode } from 'react'

import {
  ConversationRichTextExternalLinkStyled,
  ConversationRichTextLinkStyled,
} from './styles/ConversationRichTextLinkStyled'
import { ConversationRichTextStrongStyled } from './styles/ConversationRichTextStrongStyled'
import {
  type MessageToken,
  tokenizeMessageContent,
} from './tokenizeMessageContent'

export interface IConversationRichTextProps {
  content: string
}

const EXTERNAL_HREF_PATTERN = /^https?:\/\//i

const renderToken = (token: MessageToken, key: string): ReactNode => {
  switch (token.type) {
    case 'strong':
      return (
        <ConversationRichTextStrongStyled key={key}>
          {token.value}
        </ConversationRichTextStrongStyled>
      )
    case 'link':
      if (EXTERNAL_HREF_PATTERN.test(token.href)) {
        return (
          <ConversationRichTextExternalLinkStyled
            key={key}
            href={token.href}
            target='_blank'
            rel='noopener noreferrer'
          >
            {token.value}
          </ConversationRichTextExternalLinkStyled>
        )
      }
      return (
        <ConversationRichTextLinkStyled key={key} to={token.href}>
          {token.value}
        </ConversationRichTextLinkStyled>
      )
    default:
      return <Fragment key={key}>{token.value}</Fragment>
  }
}

export const ConversationRichText = ({
  content,
}: IConversationRichTextProps) => {
  let offset = 0

  return (
    <>
      {tokenizeMessageContent(content).map((token) => {
        const key = `${token.type}-${offset}`
        offset += token.value.length

        return renderToken(token, key)
      })}
    </>
  )
}
